import React, {
  useEffect, useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router';
import { Grid } from '@material-ui/core';
import { FaFile } from 'react-icons/fa';
import { formatDateTime } from 'utils';
import Flex from 'components/Flex';
import ReturnSalvePlus from 'components/Headers/ReturnSalvePlus';
import { useHttp } from '../../../hooks/http';
import Layout from '../../../components/Layout';
import Tabs, { TabsItem } from '../../../components/Tabs';
import { IOccurrence } from '../../../interfaces';
import {
  LineTitle, WrapperTitle, Number, Container,
} from '../styles';
import SeizureDetail from './SeizuresDetail';
import InvolvedsDetail from './InvolvedsDeital';
import CarsDetail from './CarsDetail';
import PcDetail from './PoliceDeital';

const Form: React.FC = () => {
  const history = useHistory();
  const { id } = useParams<{ id: string }>();
  const { httpGet } = useHttp();
  const [isloadding, setIsloadding] = useState(true);
  const [occurrence, setOccurrence] = useState({} as IOccurrence);
  const [seizureDeital, setSeizure] = useState([]);
  const [civilPolices, setcivilPolices] = useState([]);
  const [involveds, setInvolveds] = useState([]);
  const [carInvolveds, setCarInvolveds] = useState([]);

  useEffect(() => {
    async function loadOccurrence(): Promise<void> {
      const [
        responseDeital,
        responseSeizure,
        responsecivilPolices,
        responseInvolveds,
        responseCarInvolveds,
      ] = await Promise.all([
        httpGet(`/bopms/detail/${id}`),
        httpGet(`/seizures/list/${id}`),
        httpGet(`/civilPolices/list/${id}`),
        httpGet(`/involveds/list/${id}`),
        httpGet(`/involvedCars/list/${id}`),
      ]);

      setOccurrence(responseDeital.data);
      setSeizure(responseSeizure.data);
      setcivilPolices(responsecivilPolices.data);
      setInvolveds(responseInvolveds.data);
      setCarInvolveds(responseCarInvolveds.data);
      setIsloadding(false);
    }
    loadOccurrence();
  }, [httpGet, id]);

  const breadcrumbs = {
    icon: FaFile,
    links: [
      { path: '/bopm/list', title: 'Bopm' },
      { path: '', title: 'Detalhe' },
    ],
  };

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <Container>
        <ReturnSalvePlus handleReturn={() => history.push('/bopm/list')} hiddenButton handlePlus={() => history.push('')}>
          <Number>BOPM: {occurrence.bopm_number}</Number>
        </ReturnSalvePlus>
        {isloadding ? <b>loading...</b> : (
          <Tabs>
            <TabsItem title="Ocorrência" show>
              <LineTitle>
                <Grid container spacing={1}>
                  <Flex title="Equipe de Serviço (ordem de antiguidade)" xs={12} md={6} sm={6}>
                    {occurrence.service_team}
                  </Flex>

                  <Flex title="Origem da Ocorrência" xs={12} md={6} sm={6}>
                    {occurrence.origin_of_occurrence}
                  </Flex>

                  <Flex title="Tipo de registro" xs={12} md={6} sm={6}>
                    {occurrence.type_of_registration}
                  </Flex>
                  {occurrence.registration_number && (
                    <Flex title="Número do registro" xs={12} md={6} sm={6}>
                      {occurrence.registration_number}
                    </Flex>
                  )}
                  <Flex title="Tipo de Mandado" xs={12} md={6} sm={6}>
                    {occurrence.type_of_warrant}
                  </Flex>

                  {occurrence.dp && (
                    <Flex title="Delegacia" xs={12} md={6} sm={6}>
                      {`${occurrence.dp} - ${occurrence.nameDp}`}
                    </Flex>
                  )}

                  <WrapperTitle>
                    Dados da ocorrência:
                  </WrapperTitle>

                  <Flex title="Data/Hora do Fato" xs={12} md={3} sm={3}>
                    {formatDateTime(occurrence.started_at)}
                  </Flex>
                  {occurrence.dp && (
                    <>
                      <Flex title="Data/Hora chegada DP" xs={12} md={3} sm={3}>
                        {formatDateTime(occurrence.arrival_dp)}
                      </Flex>

                      <Flex title="Data/Hora atendimento DP" xs={12} md={3} sm={3}>
                        {formatDateTime(occurrence.atendence_dp)}
                      </Flex>

                      <Flex title="Data/Hora saída DP" xs={12} md={3} sm={3}>
                        {formatDateTime(occurrence.exit_dp)}
                      </Flex>
                    </>
                  )}
                  <WrapperTitle>
                    Local da ocorrência:
                  </WrapperTitle>

                  <Flex title="Logradouro" xs={12} md={6} sm={6}>
                    {occurrence.street}
                  </Flex>

                  <Flex title="Número" xs={6} sm={3} md={3}>
                    {occurrence.number}
                  </Flex>

                  <Flex title="Complemento" xs={6} sm={3} md={3}>
                    {occurrence.complement}
                  </Flex>

                  <Flex title="Bairro" xs={12} sm={6} md={6}>
                    {occurrence.neighborhood}
                  </Flex>

                  <Flex title="Município" xs={12} md={6} sm={6}>
                    {occurrence.city}
                  </Flex>

                  <Flex title="Histórico" xs={12} sm={12} md={12}>
                    {occurrence.history}
                  </Flex>
                </Grid>
              </LineTitle>
            </TabsItem>
            { civilPolices.length !== 0 && <> <PcDetail detailPolice={civilPolices} /> </> }
            { involveds.length !== 0 && <> <InvolvedsDetail detailInvolved={involveds} /> </> }
            { carInvolveds.length !== 0 && <> <CarsDetail detailCarInvolved={carInvolveds} /> </> }
            { seizureDeital.length !== 0 && (
            <>
              <SeizureDetail detailSeizures={seizureDeital} />
            </>
            ) }
          </Tabs>
        )}
      </Container>
    </Layout>
  );
};

export default Form;
